import { HttpClient } from '@angular/common/http';
import { inject, Injector, runInInjectionContext } from '@angular/core';

import { lastValueFrom, map } from 'rxjs';

import { provideReportsAppKind, provideReportsCompanyId } from '@core/reports-contracts';
import { ReportsRequestData } from '@core/reports-data';
import { AnalyticsDevFlag, ReportsAppKind } from '@core/reports-types';

export class ReportsFacade {
  constructor(private readonly injector: Injector) {}

  // use this to get analytics feature flags
  public getDevFlags(appKind: string, companyId: string | number): Promise<AnalyticsDevFlag[]> {
    return runInInjectionContext(this.injector, () => {
      const http = inject(HttpClient);
      const childInjector = Injector.create({
        providers: [
          ReportsRequestData,
          provideReportsAppKind({ useValue: <ReportsAppKind>appKind }),
          provideReportsCompanyId({ useValue: companyId }),
        ],
        parent: this.injector,
      });
      const requestData = childInjector.get(ReportsRequestData);

      return lastValueFrom(
        http
          .get<{ features: AnalyticsDevFlag[] }>(requestData.buildUrl('/features'), {
            headers: {
              ...requestData.provideAuthHeaders(),
              ...requestData.provideIdentityHeaders(),
            },
          })
          .pipe(map(resp => resp.features)),
      );
    });
  }
}
